// import axios from "axios";
import router from '../router'
import { Message } from 'element-ui'
import Api from '../api/index.js'
import { cookieHandle } from './common.js'
import axiosApi from '@/js/api';
// import { Message, Loading }from 'element-ui'
let herf = process.env.VUE_APP_BASE_API;


Vue.prototype.axios = axios;
axios.defaults.timeout = 1200000;
//拦截器
axios.interceptors.request.use(
	config => {
		let str = '';
		let url = config.url;
		let index = url.lastIndexOf("\/");
		str = url.substring(index + 1, url.length);
		const token = localStorage.getItem('token');
		const Version = localStorage.getItem('Version');
		if (token) {
			config.headers.Authorization = token;
			config.headers.Version = Version;
		}
		return config
	},
	error => {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		return Promise.reject(error)
	});
axios.defaults.withCredentials = true;
axios.interceptors.response.use(
	response => {
		if (response.data) {
			if (response.data.StatusCode == undefined) {
				return response
			}
			else {
				if (response.config.url.includes("UploadReport")) {
					return response;
				}
				if(response.config.url.includes(Api.api.login.UserExpireNoticeById)){
					return response
				}
				if (response.data.StatusCode != 200) {

					if (response.data.Msg) {

						ELEMENT.Message.error(response.data.Msg);
					}
					return false
				}
				else {
					return response;
				}

			}

		}
	},
	error => {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		if (error && error.toString().indexOf('Error: Network Error') > -1) {
			// network 错误  token过期 response 是undefined
			goToSSoLogin();
		}
		console.log(error.response && error.response.status);
		if (error.response && error.response.status == 401) {
			let href = window.location.pathname;
			if (href != '/') {
				ELEMENT.MessageBox.alert('当前系统已更新,请重新登录', '系统提示', {
					confirmButtonText: '确定',
					showClose: false,
					callback: action => {
						ssoOut('get', axiosApi.Api.api.sso.loginOut)
							.then(res => {
								if (res.data.code == 200) {
									let homeUrl = process.env.VUE_APP_HOME_URL;
									const encodeUrl = encodeURIComponent(homeUrl);
									const url = `${process.env.VUE_APP_LOGIN_URL}?callback_url=${encodeUrl}`;
									localStorage.clear()
									cookieHandle.clearCookie()
									location.href = url;
								}
							});
					}
				});
			}
		} else {
			ELEMENT.Message.error('请联系后台管理人员');
		}
	});

function goToSSoLogin() {
	let homeUrl = process.env.VUE_APP_HOME_URL;
	// let homeUrl = window.location.href;
	const encodeUrl = encodeURIComponent(homeUrl)
	const url = `${process.env.VUE_APP_LOGIN_URL}?callback_url=${encodeUrl}workbench`
	// localStorage.clear()
	cookieHandle.clearCookie()
	location.href = url
}
//获取图片验证码
const ajaxAuthCode = (type, url, parameter) => axios({
	url: herf + url,
	method: type,
	params: parameter,
	responseType: 'arraybuffer',
	headers:{
		'Content-Type':'application/json;charset=UTF-8'
	}
}).then((res) => {
	return 'data:image/png;base64,' + btoa(
		new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
}).then(data => {
	return data;
});
//get请求的封装
const ajaxGet = (type, url, parameter) => axios({
	url: herf + url,
	method: type,
	params: parameter,
	headers:{
		'Content-Type':'application/json;charset=UTF-8'
	}
}).then(res => {
	return res;
});
//post请求的封装
const ajaxPost = (type, url, parameter) => axios({
	url: herf + url,
	method: type,
	data: parameter,
	headers:{
		'Content-Type':'application/json;charset=UTF-8'
	}
}).then(res => {
	return res;
});

//uploadpost请求的封装
const uploadPost = (type, url, parameter,headers) => axios({
	url: herf + url,
	method: type,
	data: parameter,
	headers:headers
}).then(res => {
	return res;
});
//put请求的封装
const ajaxPut = (type, url, parameter) => axios({
	url: herf + url + '/' + parameter,
	method: type,
	headers:{
		'Content-Type':'application/json;charset=UTF-8'
	}
}).then(res => {
	return res;
});
const ajaxPutBody = (type, url, parameter) => axios({
	url: herf + url,
	method: type,
	data: parameter,
	headers:{
		'Content-Type':'application/json;charset=UTF-8'
	}
}).then(res => {
	return res;
});
//Delete请求
const ajaxDelete = (url, parameter) => {
	return axios.delete(herf + url, {
	  params: parameter,
	  headers: {
		'Content-Type': 'application/json;charset=UTF-8'
	  }
	}).then(response => {
	  return response.data;
	}).catch(error => {
	  throw error;
	});
  };
// 导出
const exportExcel = function (url) {
	return herf + url
}

function ssoOutParma() {
	let loginUserCookieStr = cookieHandle.getCookie(process.env.VUE_APP_BASE_USERINFO),
		data = {},
		logincodeval = '';
	const logincode = JSON.parse(decodeURIComponent(loginUserCookieStr)).logincode,
		phone = JSON.parse(decodeURIComponent(loginUserCookieStr)).phone;
	if (logincode && (logincode != null || logincode != '' || logincode != undefined)) {
		logincodeval = logincode;
	} else {
		logincodeval = phone;
	}
	return logincodeval
}

const ssoOut = (type, url) => axios({
	url: process.env.VUE_APP_BASE_SSO_API + url,
	method: type,
	params: { logincode: ssoOutParma() },
	headers:{
		'Content-Type':'application/json;charset=UTF-8'
	}
}).then(res => {
	return res;
});
export default {
	ajaxAuthCode,
	ajaxGet,
	ajaxPost,
	herf,
	exportExcel,
	Api,
	ssoOut,
	uploadPost,
	ajaxPut,
	ajaxDelete,
	ajaxPutBody,
}
